
// import 'vidstack/icons';

import 'vidstack/player';
import 'vidstack/player/layouts/default';
import 'vidstack/player/ui';

import 'mapbox-gl/dist/mapbox-gl.css';
import './css/main.css';

import barba from '@barba/core';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// import 'vidstack/player';
// import 'vidstack/player/layouts/default';
// import 'vidstack/player/ui';

barba.init({
    debug: true,
    timeout: 7000,
    transitions: [
        {
            name: 'opacity-transition',
            leave(data) {
                return gsap.to(data.current.container, {
                    opacity: 0
                });
            },
            enter(data) {
            },
            after(data) {
                return gsap.from(data.next.container, {
                    opacity: 0
                });
            },
            afterOnce(data) {
            },
            once(data) {
            }
        },
        {
            name: 'swipeFromRight-transition',
            from: {
                // define a custom rule based on the trigger class
                custom: ({ trigger }) => {
                  return trigger.classList && trigger.classList.contains('swipeFromRight');
                },
            },
            leave(data) {
                return gsap.to(data.current.container, {
                    x: '-100%'
                });
            },
            enter(data) {
            },
            after(data) {
                return gsap.from(data.next.container, {
                    x: '100%',
                    y: 0
                });
            },
            afterOnce(data) {
            },
            once(data) {
            }
        },
        {
            name: 'swipeFromLeft-transition',
            from: {
                // define a custom rule based on the trigger class
                custom: ({ trigger }) => {
                  return trigger.classList && trigger.classList.contains('swipeFromLeft');
                },
            },
            leave(data) {
                return gsap.to(data.current.container, {
                    x: '100%'
                });
            },
            enter(data) {
            },
            after(data) {
                return gsap.from(data.next.container, {
                    x: '-100%'
                });
            },
            afterOnce(data) {
            },
            once(data) {
            }
        }
    ],
});


function scrollToTop() {
// window.scrollTo({top: 0, behavior: 'smooth'});
window.scrollTo({top: 0});
};




function hamburgerToggle(preset) {
    import(/* webpackChunkName: "hamburgerToggle" */ "./js/components/hamburgerToggle.js").then(module => {
        const toggle = module.default;
        toggle(preset);
    });
}

let hamburgerOuter = document.getElementById("hamburgerOuter");
hamburgerOuter.addEventListener("click", function() {hamburgerToggle()});

let menuCloser = document.getElementById('dropdownCloser');
menuCloser.addEventListener("click", () => {hamburgerToggle('c')});



function videos() {
    let vidPlayers = document.querySelectorAll('media-player');
    if (vidPlayers.length > 0) {
        let vd;
        for (vd=0; vd < vidPlayers.length; vd++) {
            vidPlayers[vd].addEventListener('provider-change', (event) => {
                const provider = event.detail;
                if (provider?.type === 'hls') {
                    console.log('HLS config change');
                    provider.config = { startLevel: 5 };
                };
            });
        };
    };
};

function castleAnim() {
    // let anims = document.getElementsByClassName('castleAnim');
    // if (anims.length > 0) {
    //     let ca;
    //     for (ca = 0; ca < anims.length; ca++) {
    //         let time = (ca) * 1000;
    //         let element = anims[ca];
    //         console.log(time);
    //         setTimeout(()  => {
    //             setInterval(() => {
    //                 element.classList.remove('hidden');
    //             }, 3000);
    //             setTimeout(() => {
    //                 setInterval(() => {
    //                     element.classList.add('hidden');
    //                 }, 3000);
    //             }, 1000)
                
    //         }, time)
    //     }
    // }
}

function galleryCheck() {
    let galleries = document.getElementsByClassName('gallery');
    if (galleries.length > 0) {
      import(/* webpackChunkName: "gallery" */ "./js/components/gallery.js").then(module => {
        const galleryGo = module.default;
        galleryGo();
      });
    };
};

function mapCheck() {
    let maps = document.getElementsByClassName('map');
    if (maps.length > 0) {
        import(/* webpackChunkName: "map" */ "./js/components/map.js").then(module => {
            const mapGo = module.default;
            setTimeout(() => {
                mapGo();
            }, 500)
            
          });
    }
}

let theLogo = document.getElementById('monLogo');
function logoRemove() {
    ScrollTrigger.create({
        trigger: '#footer',
        start: 'top bottom',
        end: 'bottom 90%',
        // onEnter: (self) => thebub.classList.remove('-translate-y-[120%]'),
        // onLeave: (self) => thebub.classList.add('-translate-y-[120%]'),
        onEnter: (self) => theLogo.classList.add('hidden'),
        onLeave: (self) => theLogo.classList.remove('hidden'),
        onLeaveBack: (self) => theLogo.classList.remove('hidden'),
        // markers: {startColor: "black", endColor: "black", fontSize: "18px", fontWeight: "bold", indent: 20}
    })
}

function killScroll() {
    let Alltrigger = ScrollTrigger.getAll()
    for (let i = 0; i < Alltrigger.length; i++) {
    Alltrigger[i].kill(true)
    }
}


function menuCheck(data) {
    let tickBut = document.getElementById('ticketsButton');
    if (tickBut != undefined && tickBut != null) {
            if (data.next.namespace == 'tickets' || data.next.namespace == 'artists' ) {
                tickBut.classList.add('opacity-0');
                
                setTimeout(() => {
                    tickBut.classList.add('hidden');
                }, 600)
                
            } else {
                tickBut.classList.remove('hidden');
                setTimeout(() => {
                    tickBut.classList.remove('opacity-0');
                }, 800)
            }
    } else {


    };
}


function autoRefresh() {
    let refreshIt = document.getElementsByClassName('autoRefresh');
    if (refreshIt.length > 0) {
        import(/* webpackChunkName: "autoRefresh" */ "./js/components/autoRefresh.js").then(module => {
            const refreshGo = module.default;
            refreshGo();
          });
    }
}

function weez() {
    let weezIt = document.getElementsByClassName('weez');
    if (weezIt.length > 0) {
        import(/* webpackChunkName: "weez" */ "./js/components/weez.js").then(module => {
            const weezGo = module.default;
            weezGo();
          });
    }
}

function tickerCheck() {
    let tickers = document.querySelectorAll('[data-ticker]');
    if (tickers.length > 0) {
        import(/* webpackChunkName: "ticker" */ "./js/components/ticker.js").then(module => {
            const tickerGo = module.default;
            tickerGo();
        });
    }
}

function bgPushAnim() {
    gsap.to(['#bgGradient', '#sprayStripes'], {
        yPercent: -100,
        ease: 'none',
        scrollTrigger: {
            trigger: '#footer',
            start: 'top bottom',
            end: 'top top',
            scrub: true,
            clamp: true,
        }
    });
}

function bustaAnim() {
    const busta = document.getElementById('bustaEl');
    if (!busta) return;
    gsap.to(busta, {
        yPercent: 180,
        ease: 'none',
        scrollTrigger: {
            trigger: document.documentElement,
            start: 'top top',
            end: '+=250',
            scrub: 1,
        }
    });
}

function bustaCheck(namespace) {
    const busta = document.getElementById('bustaEl');
    if (!busta) return;
    if (namespace === 'home') {
        gsap.set(busta, { xPercent: -50, yPercent: 50 });
        busta.classList.remove('hidden');
    } else {
        busta.classList.add('hidden');
    }
}






barba.hooks.once((data) => {
    castleAnim();
    videos();
    galleryCheck();
    mapCheck();
    tickerCheck();
    logoRemove();
    bgPushAnim();
    menuCheck(data);
    autoRefresh();
    bustaCheck(data.next.namespace);
    if (data.next.namespace === 'home') bustaAnim();

});

barba.hooks.afterOnce((data) => {
    weez();
});

barba.hooks.before((data) => {
    hamburgerToggle('c');
})

barba.hooks.beforeEnter((data) => {
    scrollToTop();
    videos();
    galleryCheck();
    mapCheck();
    tickerCheck();
    menuCheck(data);
    bustaCheck(data.next.namespace);
});


barba.hooks.after((data) => {
    castleAnim();
    theLogo.classList.remove('hidden'),
    killScroll();
    logoRemove();
    bgPushAnim();
    autoRefresh();
    weez();
    if (data.next.namespace === 'home') bustaAnim();

});
